import { executeRequest } from '@jfs/network'
import axios from 'axios'
import { RootStore } from '../data/store'
import { getNetworkResponseError, isStatusSuccess } from '../util/utill'
import { APIEndPoints } from './APIEndPoints'
import { extendUserSession } from './ExtendUserSession'
import { apiConfig } from './config'

const responseParser = (data: any) => {
  if (isStatusSuccess(data?.data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const refreshUserSessionParser = (data: any) => {
  if (isStatusSuccess(data)) {
    const userAccessToken = data?.session?.accessToken?.tokenValue
    const userRefreshToken = data?.session?.refreshToken?.tokenValue
    const userIdentifierToken = data?.session?.userIdentifierToken
    return { userAccessToken, userRefreshToken, userIdentifierToken }
  } else {
    throw getNetworkResponseError(data)
  }
}

export const linkAadhaarOtp = (tokens: any, req: any) => {
  const reqConfig = apiConfig(tokens)
  return axios
    .post(`${reqConfig.baseUrl}${APIEndPoints.linkAadhaar}`, req, {
      headers: reqConfig.headers,
      timeout: reqConfig.timeOut,
    })
    .then((res) => {
      return responseParser(res)
    })
    .catch((err) => {
      if (err?.response) {
        return responseParser(err?.response)
      } else {
        throw err
      }
    })
}

export const refreshUserSession: any = (tokens: any, mobileNo: any) => {
  const { userAccessToken, userRefreshToken, CHANNEL_ID } = tokens ?? {}
  const extendUserReq = extendUserSession(userAccessToken, userRefreshToken, CHANNEL_ID, mobileNo)
    console.log(extendUserReq,"sessiondatacheckk2::")
  return executeRequest(extendUserReq).then(({ data }) => {
    console.log(data,"sessiondatacheckk2::")
    return refreshUserSessionParser(data)
  })
}

export const getLinkAadhaarOtpRequest = (aadhaarNo: string, mobileNumber: string, otp: string) => {
  return {
    type: 1,
    value: mobileNumber,
    identityDto: {
      type: '1',
      value: aadhaarNo,
      method: '04',
      consent: btoa(RootStore.consents.getConsent('LINK_AADHAAR')),
      authDto: {
        mode: '30',
        value: otp,
      },
    },
  }
}
